import React from "react";
import { LogOut } from "lucide-react";
import ScrollReveal from "@/components/ScrollReveal/ScrollReveal";

const RichText = ({ text }) =>
  text.split(/\*\*(.+?)\*\*/g).map((part, i) =>
    i % 2 ? <strong key={i}>{part}</strong> : <React.Fragment key={i}>{part}</React.Fragment>
  );

const StatsGrid = ({ section }) => (
  <div className={`investor-stats-grid${section.columns === 3 ? " investor-stats-grid--3" : ""}`}>
    {section.items.map((m, i) => (
      <div className="glass investor-stat-card" key={m.label} data-testid={`${section.id}-stat-${i}`}>
        <div className="investor-stat-value">{m.value}</div>
        <div className="investor-stat-label">{m.label}</div>
      </div>
    ))}
  </div>
);

const Prose = ({ section }) => (
  <div className="prose">
    {section.paragraphs.map((p) => (
      <p key={p}>
        <RichText text={p} />
      </p>
    ))}
  </div>
);

const ContactExtras = ({ section }) => (
  <>
    <p className="body" style={{ maxWidth: 540, margin: "16px auto 0" }}>
      {section.text}
    </p>
    <p className="mono-sm" style={{ marginTop: 32, color: "var(--color-text-primary)" }} data-testid="investor-contact-email">
      {section.email}
    </p>
  </>
);

const BODY = { stats: StatsGrid, prose: Prose };

const Section = ({ section, index }) => {
  const Body = BODY[section.type];
  return (
    <section
      className={`section ${index % 2 ? "section-deep" : "section-surface"}`}
      data-testid={`section-${section.id}`}
    >
      <div className="container">
        <ScrollReveal>
          <div className="section-head">
            <span className="eyebrow">{section.eyebrow}</span>
            <h2 className="h-2">{section.title}</h2>
            {section.type === "contact" && <ContactExtras section={section} />}
          </div>
        </ScrollReveal>
        {Body && (
          <ScrollReveal delay={0.1}>
            <Body section={section} />
          </ScrollReveal>
        )}
      </div>
    </section>
  );
};

export const InvestorContent = ({ content, onLogout }) => (
  <>
    <section className="page-intro" data-testid="investor-content">
      <div className="container">
        <ScrollReveal>
          <span className="investor-classified">{content.classified}</span>
          <h1 className="h-1">{content.title}</h1>
          <p className="body-lg page-intro-sub">{content.subtitle}</p>
          <button type="button" className="btn btn-ghost btn-sm investor-logout" onClick={onLogout} data-testid="investor-logout">
            <LogOut size={16} />
            Sair
          </button>
        </ScrollReveal>
      </div>
    </section>
    {content.sections.map((s, i) => (
      <Section key={s.id} section={s} index={i} />
    ))}
  </>
);
